import StepBlock from "./styled-components/StepBlock";
import StepGroup from "./styled-components/StepGroup";
import StepProgress from "./styled-components/StepProgress";
import StepTitle from "./styled-components/StepTitle";
import StepperContainer from "./styled-components/StepperContainer";

export interface Step {
  name: string;
  progress: number; // 0-100
}

export interface StepperProps {
  steps: Step[];
  currentStep: number;
}

function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <StepperContainer>
      {steps.map((step, index) => (
        <StepGroup key={`stepper__${step.name}`}>
          {index === currentStep && <StepTitle>{step.name}</StepTitle>}
          <StepBlock isCurrentStep={index === currentStep}>
            <StepProgress progress={step.progress} />
          </StepBlock>
        </StepGroup>
      ))}
    </StepperContainer>
  );
}

export default Stepper;
